import { render, staticRenderFns } from "./RVGuide.vue?vue&type=template&id=65ad8b52&"
import script from "./RVGuide.vue?vue&type=script&lang=js&"
export * from "./RVGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/RiboVision3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ad8b52')) {
      api.createRecord('65ad8b52', component.options)
    } else {
      api.reload('65ad8b52', component.options)
    }
    module.hot.accept("./RVGuide.vue?vue&type=template&id=65ad8b52&", function () {
      api.rerender('65ad8b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components/RVGuide.vue"
export default component.exports